// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/Content/Content/Charge/mutation-delete.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Charges_Content_Content_Charge($id: numeric!) {
  delete_vaxiom_misc_fee_charge_templates_by_pk(id: $id) {
    id
  }
}

`